import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { usePercentFormatter } from '@mint-lib/formatting-hooks';
import { useTranslation } from '@mint-lib/i18n';

import { NO_DECIMALS } from '../../../consts/index.js';
import type { CellRendererCommonType } from '../../../types/grid.types.js';
import { getFormattedValue } from '../../../utils/getFormattedValue.jsx';

export const PercentRenderer = (
  params: CustomCellRendererProps & CellRendererCommonType,
) => {
  const { t } = useTranslation('@myn/planning_v2');
  const formatter = usePercentFormatter();

  const formatterFn = () => {
    return formatter.format(params.value, {
      minDecimals: params.decimalPlaces ?? NO_DECIMALS,
      maxDecimals: params.decimalPlaces ?? NO_DECIMALS,
    })?.formatted;
  };

  const formattedValue = getFormattedValue(params, {
    formatterFn,
    placeholderText: t('Insert'),
  });

  return formattedValue;
};
